const config = {
    API_KEY: 'AIzaSyB40hK4vfWOttqRmLeWW4RaL7Y6xiCnGlQ',
};

export default config;
